import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createRef } from 'react';
var LazyLoadedComponent = /*#__PURE__*/function (_React$Component) {
  function LazyLoadedComponent(props) {
    var _this;
    _classCallCheck(this, LazyLoadedComponent);
    _this = _callSuper(this, LazyLoadedComponent, [props]);
    _defineProperty(_this, "componentRef", void 0);
    _defineProperty(_this, "options", {});
    _defineProperty(_this, "tag", _this.props.as || 'section');
    _this.componentRef = createRef();
    if (_this.props.id) {
      _this.options.id = _this.props.id;
    }
    _this.onLoad = _this.onLoad.bind(_this);
    _this.state = {
      loaded: false
    };
    return _this;
  }
  _inherits(LazyLoadedComponent, _React$Component);
  return _createClass(LazyLoadedComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (this.props.lazyLoading) {
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              _this2.setState(function () {
                return {
                  loaded: true
                };
              });
              _this2.onLoad();
              obs.disconnect();
            }
          });
        }, {
          rootMargin: this.props.rootMargin || '250px',
          threshold: 0
        });
        if (this.componentRef.current) {
          observer.observe(this.componentRef.current);
        }
        return function () {
          observer.disconnect();
        };
      }
      return null;
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      if (this.props.onLoad) {
        this.props.onLoad();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var CustomTag = this.tag;
      return React.createElement(CustomTag, _objectSpread(_objectSpread({}, this.options), {}, {
        ref: this.componentRef,
        className: "".concat(this.state.loaded ? 'loaded' : '', " ").concat(this.props.className || '')
      }), this.props.children);
    }
  }]);
}(React.Component);
export { LazyLoadedComponent as default };